import * as React from 'react';
import {StatelessComponent} from 'react';
import {Link} from 'react-router-dom';

import './styles.sass';

export interface IAuthHeaderProps {
  children?: any;
}

export const AuthHeader: StatelessComponent<IAuthHeaderProps> = ({
  children,
}: IAuthHeaderProps) => (
  <div className={'auth-header'}>
    <h3 className={'auth-header__title'}>
      {children}
    </h3>

    <Link to='/' className={'auth-header__close'} tabIndex={-1}>X</Link>
  </div>
);
